"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadeElement = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const shadeElementStyles = theme => ({
  borderRadius: '50%',
  display: 'inline-block',
  height: 7,
  margin: theme.spacing(1, 1, 1.2),
  width: 7
});
const ColorShadeElement = (0, _mui.styled)('div')(({
  theme,
  ownerState: {
    background
  }
}) => ({
  ...shadeElementStyles(theme),
  background
}));
const ImageShadeElement = (0, _mui.styled)('img')(({
  theme
}) => shadeElementStyles(theme));
const getLinearGradient = colors => `linear-gradient(to right, ${colors[0]}, ${colors[0]} 50%, ${colors[1]} 50%)`;
const ShadeElement = ({
  colorHexCode,
  colorImageSrc
}) => {
  const colorHexCodes = colorHexCode?.split(',').filter(hexCode => Boolean(hexCode));
  if (colorHexCodes && colorHexCodes.length > 0) {
    let ownerState;
    if (colorHexCodes.length > 1) {
      ownerState = {
        background: getLinearGradient(colorHexCodes)
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ColorShadeElement, {
        ownerState: ownerState
      });
    }
    ownerState = {
      background: colorHexCodes[0]
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ColorShadeElement, {
      ownerState: ownerState
    });
  }
  if (colorImageSrc) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ImageShadeElement, {
      src: colorImageSrc,
      alt: ""
    });
  }
  return null;
};
exports.ShadeElement = ShadeElement;
